const styles = {
  blue: {
    color: "rgb(33,77,142)",
    paddingRight: "0",
  },
  red: {
    color: "rgb(220,38,72)",
    paddingLeft: "0",
  },
  selector: {
    width: "90vw",
    marginLeft: "5vw",
    marginBottom: "5px",
  },
  nextButton: {
    width: "90vw",
    marginLeft: "5vw",
    marginTop: "10vh",
    backgroundColor: "rgb(33,77,142)",
    border: "1px solid rgb(33,77,142)",
    borderRadius: "0",
    height: "10vh",
  },
  selectLabel: {
    width: "90vw",
    marginTop: "5px",
    marginLeft: "6.9vw",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: "18px",
    letterSpacing: "0.2px",
    color: "#6D7885",
    padding: "0",
    marginBottom: "8px",
  },
  blockMO: {
    width: "90vw",
    marginTop: "12px",
    marginLeft: "6.9vw",
    padding: "0",
  },
  blockMOName: {
    padding: "0",
    display: "block",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "18px",
    letterSpacing: "0.2px",
    color: "#000000",
    width: "81.87vw",
  },
  blockMODesc: {
    padding: "0",
    display: "block",
    fontFamily: "IBM Plex Sans",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "13px",
    lineHeight: "18px",
    color: "#06844D",
    width: "81.87vw",
  },
  inputSelector: {
    width: "87.46vw",
    marginLeft: "6.26vw",
  },
  headerText: {
    position: "relative",
    paddingLeft: "8.8vw",
    fontFamily: "IBM Plex Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "clamp(20px, 6.13vw, 35px)",
    lineHeight: "clamp(24px, 7.47vw, 43px)",
    color: "#000000",
  },
  errorMessage: {
    width: "324px",
    marginLeft: "6.9vw",
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0.2px",
    color: "#6D7885",
    marginTop: "6px",
    marginBottom: "18px",
  },
  doctorsErrorMessage: {
    marginLeft: "auto",
    marginRight: "auto",
    width: "296px",
    fontFamily: "Roboto",
    fontSize: "16px",
    lineHeight: "20px",
    letterSpacing: "0.1px",
    color: "#818C99",
    fontWeight: "400",
    marginTop: "172px",
    textAlign: "center",
  },
};

export default styles;
